// @flow
import React from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-flexbox-grid';
import * as selectors from '../../reducers';
import * as userActions from '../../actions/users';
import PopupContainer from '../PopupContainer';

import PopupContent from '../PopupContent';
import styles from './smsCodePopupContainer.css';
import type { USER_TYPE } from '../../types/users';

type SMSCodePopupContentPropTypes = {
  userId: string,
  user: USER_TYPE,
  startFetchUserCode: Function
}
class SMSCodePopupContent extends React.Component<SMSCodePopupContentPropTypes> {
  constructor(props) {
    super(props);
    const { startFetchUserCode, userId, user } = props;
    startFetchUserCode(userId, user.id);
  }

  render() {
    const { user } = this.props;
    return (
      <PopupContainer size="small">
        <PopupContent className={styles.createRoutePopupContent} size="small">
          <Grid>
            <Row>
              <Col xs={12}>
                <div className={styles.smsContainer}>
                  <h2 className={styles.smsTitleText}>
                    Se generó correctamente el código de ingreso para
                    <span className={styles.blueText}>
                      {' '}
                      {user.first_name}
                      {' '}
                      {user.last_name}
                      {' '}
                    </span>
                  </h2>
                  <p className={styles.descriptionText}>
                    Este código durará únicamente 5 minutos luego de ser generado:
                  </p>
                  <h1 className={styles.code}>
                    { user.token }
                  </h1>
                </div>
              </Col>
            </Row>
          </Grid>
        </PopupContent>
      </PopupContainer>
    );
  }
}
const SMSCodePopup = connect(
  (state, props) => {
    const { id } = props;
    const user = selectors.getOneUser(state, id);
    return {
      user,
      userId: user.user_id,
    };
  },
  dispatch => ({
    startFetchUserCode: (id, stateUserId) => dispatch(userActions.startFetchUserCode(id,
      stateUserId)),
  }),
)(SMSCodePopupContent);

export default SMSCodePopup;



// WEBPACK FOOTER //
// ./src/scripts/components/SMSCodePopupContent/index.jsx